module.exports = __webpack_public_path__ + "static/media/icon-heart-active-red.a452521f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-heart-active-red.svg
// module id = 1459
// module chunks = 0